"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M14 8c0-.438.113-1.206.541-1.848C14.948 5.542 15.666 5 17 5s2.052.542 2.459 1.152C19.887 6.794 20 7.562 20 8v2.5a.5.5 0 0 0 1 0V8c0-.562-.137-1.544-.709-2.402C19.698 4.708 18.666 4 17 4s-2.698.708-3.291 1.598C13.137 6.456 13 7.438 13 8v2H6.5A1.5 1.5 0 0 0 5 11.5v7A1.5 1.5 0 0 0 6.5 20h9a1.5 1.5 0 0 0 1.5-1.5v-7a1.5 1.5 0 0 0-1.5-1.5H14zm-3 6a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 .5-.5"
}), 'UnlockFilled');
